import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/mail/';

export function apiMail(mail) {
	const form_data = objectToFormData(mail);
	return api.post(prefix, form_data);
}

export function apiMailSearch(param) {
	return api.get(prefix + 'search', { params: param });
}
